import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Brain, Check, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr as errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function DailyQuiz() {
  const { refreshUser: refresh } = useAuth();
  const [d, setD] = useState(null);
  const [pick, setPick] = useState([]);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/ai/quiz").then(({ data }) => { setD(data); if (data.done) setRes({ ...data.done, solution: data.questions.map((q) => q.answer) }); }).catch(() => setD(false)); }, []);
  if (d === false) return null;
  if (!d) return <div id="tagesquiz" className="rounded-3xl bg-white border border-violet-100 p-6 flex items-center gap-2 text-sm text-slate-400" data-testid="daily-quiz-loading"><Loader2 className="w-4 h-4 animate-spin" /> Tagesquiz wird geladen …</div>;
  const answers = res?.answers || pick;
  const submit = async () => {
    setBusy(true);
    try { const { data } = await api.post("/ai/quiz", { answers: pick }); setRes(data); refresh?.(); toast.success(data.correct ? `${data.correct}/3 richtig – +${data.points} Punkte! 🧠` : "Leider keine richtig – morgen gibt's ein neues Quiz!"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section id="tagesquiz" className="glow-pulse scroll-mt-24 rounded-3xl bg-gradient-to-br from-violet-50 via-white to-rose-50 border border-violet-100 p-5 sm:p-6 space-y-4" data-testid="daily-quiz">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-2xl bg-violet-500 text-white flex items-center justify-center"><Brain className="w-6 h-6" /></span>
        <div className="flex-1"><h2 className="font-display text-xl font-extrabold">Tagesquiz</h2><p className="text-xs text-slate-500">3 Fragen · {d.points_per_correct} Punkte pro richtige Antwort · jeden Tag neu</p></div>
        {res && <span className="text-sm font-extrabold text-violet-600" data-testid="daily-quiz-score">{res.correct}/3</span>}
      </div>
      {d.questions.map((q, i) => (
        <div key={i} className="space-y-2" data-testid={`daily-quiz-q-${i}`}>
          <p className="font-bold text-sm">{i + 1}. {q.q}</p>
          <div className="grid grid-cols-2 gap-2">
            {q.options.map((o, j) => {
              const sol = res?.solution?.[i], chosen = answers[i] === j;
              const cls = res ? (j === sol ? "bg-emerald-100 border-emerald-300 text-emerald-800" : chosen ? "bg-rose-100 border-rose-300 text-rose-700" : "bg-white border-slate-100 text-slate-400")
                : chosen ? "bg-violet-500 border-violet-500 text-white" : "bg-white border-violet-100 hover:border-violet-300";
              return <button key={j} disabled={!!res} onClick={() => setPick((p) => { const n = [...p]; n[i] = j; return n; })} data-testid={`daily-quiz-q-${i}-opt-${j}`}
                className={`min-h-11 px-3 py-2 rounded-xl border text-sm font-semibold text-left flex items-center gap-1.5 transition-colors ${cls}`}>
                {res && j === sol && <Check className="w-4 h-4 shrink-0" />}{res && chosen && j !== sol && <X className="w-4 h-4 shrink-0" />}{o}</button>;
            })}
          </div>
        </div>
      ))}
      {!res && <button onClick={submit} disabled={busy || pick.filter((x) => x !== undefined).length < d.questions.length} data-testid="daily-quiz-submit"
        className="w-full h-12 rounded-full bg-violet-600 hover:bg-violet-700 text-white font-bold disabled:opacity-50 flex items-center justify-center gap-2 transition-colors">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Antworten abschicken</button>}
      {res && <p className="text-center text-xs text-slate-500" data-testid="daily-quiz-done">Morgen gibt's ein neues Quiz. <Link to="/punkte-sammeln" className="font-bold text-violet-600">Weitere Punkte sammeln →</Link></p>}
    </section>
  );
}
